import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './styles.less';

const AddProfileButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="add-profile-button">
      <Button className="add-profile-button__button" type="link" onClick={onClick}>
        {t('profiles.addConfiguration')}
      </Button>
    </div>
  );
};

AddProfileButton.propTypes = {
  onClick: PropTypes.func,
};

AddProfileButton.defaultProps = {
  onClick: null,
};

export default AddProfileButton;
